import React from "react";
import {logAction} from "../../../../logging/logEvent";
import {NeutralTertiaryButton} from "../../../elements/Buttons";
import {highlightColour} from "../../../../style/styleConsts";
import styled from "styled-components";
import {useSelector} from "react-redux";

const OldTimLink = styled(NeutralTertiaryButton)`
    :after {
        content: "➔";
        margin-left: 7px;
        color: ${highlightColour};
        font-size: 120%;
        line-height: initial;
    }   
`;
export const BackToOldTIMButton = () => {
    const newUiOnly = useSelector(state => state.userIdentity.newUiOnly);
    if (newUiOnly) {
        return null;
    }
    const onClick = () => logAction({type: `OLD_TIM_LINK_CLICKED`});
    return <OldTimLink href="/TradeIdeasMonitor/monitor?ui=v1" onClick={onClick}>Back to Old TIM</OldTimLink>
};